import validate from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "check-form-token": () => import("/opt/buildhome/repo/middleware/check-form-token.js"),
  "check-form-type": () => import("/opt/buildhome/repo/middleware/check-form-type.js")
}